import { getPromise } from "./request-promise";

export function getStrayosDashboardLicense(userId: number) {
    return getPromise(`api/v1/user_licenses/get_strayos_dashboards_license?user_id=${userId}`,data=> data ?? null);
}
